/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { BillOfQuantity } from 'src/app/_model/bill-of-quantity';

@Injectable()
export abstract class BillOfQuantitiesDaoService implements Resetable {
  public abstract saveBillOfQuantities(
    billOfQuantities: BillOfQuantity[]
  ): Promise<void>;
  public abstract getBillOfQuantities(): Promise<BillOfQuantity[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
